import React from 'react';
import { NavLink } from 'react-router-dom';

const UsersCrumb = () => <NavLink to="/admin/users">User Management</NavLink>;

export default UsersCrumb;
